// extracted by mini-css-extract-plugin
module.exports = {"container":"_2tjZABPRdoy_r7p-wkkIfM","wrapper":"_2ordW_Oz417Ka2DLPBXXPu"};